var map = {
	"./Amica/GPT/feature": [
		3447,
		396,
		813,
		967
	],
	"./Corriere/Adobe/feature": [
		4634,
		396,
		715
	],
	"./Corriere/CMP/feature": [
		4091,
		262
	],
	"./Corriere/Datalayer/feature": [
		9601,
		753
	],
	"./Corriere/GPT/feature": [
		1340,
		396,
		813,
		685
	],
	"./Corriere/Gtag/feature": [
		8878,
		81
	],
	"./Corriere/Nielsen/feature": [
		9329,
		396,
		112
	],
	"./Corriere/Permutive/feature": [
		4364,
		396,
		835
	],
	"./Corriere/Revive/feature": [
		3860,
		216
	],
	"./Living/GPT/feature": [
		2309,
		396,
		813,
		485
	],
	"./Oggi/GPT/feature": [
		128,
		396,
		813,
		352
	],
	"./Style/GPT/feature": [
		5427,
		396,
		813,
		307
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1657;
module.exports = webpackAsyncContext;